import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/ntocc-tms-api/statistics/platFormDataStatistics',
        method: 'get',
        params: query
    })
}